import fetch from './clientFetch';

export async function getInviteVCode(body) {
  const data = await fetch({
    url: '/api/invite/send_validate_code',
    method: 'post',
    data: body,
    client: true,
  });
  return data;
}

export async function validateInvite(body) {
  const data = await fetch({
    url: '/api/invite/validate_invite',
    method: 'post',
    data: body,
    client: true,
  });
  return data;
}
